import React from 'react';
import PropTypes from 'prop-types';
import StarRating from 'components/common/StarRating';
import { useProductRating } from 'hooks/useProductHook';
import Charging from 'components/common/Charging';
import { formattedDate } from 'helpers/utils';

const Reviews = ({ product }) => {
 const { reviews, loading } = useProductRating({ product, ratings: true });

 if (loading) return <Charging />;

 if (reviews?.length)
  return reviews.map((review, index) => (
   <div key={index}>
    <div className="mb-1">
     <StarRating className="fs--1" readonly rating={review.rating} />
     <span className="ms-3 text-dark fw-semi-bold">{review.title}</span>
    </div>
    <p className="fs--1 mb-2 text-600">
     By {review.author.name} • {formattedDate(review.createdAt, 'LLLL')}
    </p>
    <p className="mb-0">{review.text}</p>
    {!(index === reviews.length - 1) && <hr className="my-4" />}
   </div>
  ));

 return <></>;
};

Reviews.propTypes = { product: PropTypes.string };

Reviews.defaultProps = { product: '' };

export default Reviews;
